import { TZDate as e } from "../node_modules/@date-fns/tz/date/index.js";
import { tz as t } from "../node_modules/@date-fns/tz/tz/index.js";
import "../node_modules/@date-fns/tz/index.js";
import n from "../node_modules/date-fns/startOfDay.js";
import r from "../node_modules/date-fns/format.js";
//#region lib/utils/dates.ts
var i = 1e10, a = (e, { compact: t = !1, timezone: n, includeDate: r = !0, includeTime: a = !1, timeZoneDisplay: o = "shortGeneric", ...s } = {}) => {
	if (!e) return "";
	e instanceof Date && (e = e.getTime());
	let c;
	if (typeof e == "number") c = new Date(e < i ? e * 1e3 : e);
	else if (typeof e == "string") {
		if (c = new Date(e), Number.isNaN(c.getTime()) && (c = /* @__PURE__ */ new Date(Number(e) * 1e3), Number.isNaN(c.getTime()))) return "";
	} else return "";
	return Number.isNaN(c.getTime()) ? "" : r ? c.toLocaleDateString("en-US", {
		timeZone: n,
		timeZoneName: o === !1 ? void 0 : o,
		month: t ? "numeric" : "short",
		day: "numeric",
		year: t ? "2-digit" : "numeric",
		hour: a ? "numeric" : void 0,
		minute: a ? "2-digit" : void 0,
		...s
	}) : c.toLocaleTimeString("en-US", {
		timeZone: n,
		timeZoneName: o === !1 ? void 0 : o,
		hour: a ? "numeric" : void 0,
		minute: a ? "2-digit" : void 0,
		...s
	});
};
function o(e) {
	if (!e) return "";
	try {
		return (/* @__PURE__ */ new Date()).toLocaleTimeString("en-US", {
			timeZone: e,
			timeZoneName: "short"
		}).split(" ")[2];
	} catch {
		return "";
	}
}
function s(e) {
	return e ? (/* @__PURE__ */ new Date(`January 1, 1970 ${e}`)).toLocaleTimeString("en-US", {
		hour12: !0,
		timeStyle: "short"
	}) : "";
}
function c(e, t) {
	return !e || !t ? !1 : e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
var l = /^\d{4}-\d{2}-\d{2}$/;
function u(e) {
	if (typeof e != "string" || !l.test(e)) return !1;
	let [t, n, r] = e.split("-").map(Number), i = new Date(t, n - 1, r);
	return i.getFullYear() === t && i.getMonth() === n - 1 && i.getDate() === r;
}
function d(r, i) {
	if (typeof r == "string" && u(r)) {
		let [t, n, a] = r.split("-").map(Number);
		return i ? new e(t, n - 1, a, i) : new Date(t, n - 1, a);
	}
	let a;
	return a = typeof r == "number" ? r * 1e3 : r instanceof Date ? r.getTime() : Date.now(), n(a, i ? { in: t(i) } : void 0);
}
function f(e, t) {
	return Math.floor(d(e, t).getTime() / 1e3);
}
function p(e, t) {
	return r(d(e, t), "yyyy-MM-dd");
}
function m(e) {
	return (/* @__PURE__ */ new Date(e * 1e3)).toISOString().replace(/\.\d{3}Z$/, "Z");
}
function h(e, t) {
	return m(f(e, t));
}
function g(e, t) {
	return m(f(f(e, t) + 108e3, t) - 1);
}
function _(e, t) {
	if (e != null && e !== "") return p(e, t);
}
//#endregion
export { a as formatDate, _ as formatISODate, s as formatTime, o as getTimezoneAbbreviation, u as isCalendarDayString, c as isSameDay, g as zonedDayEndIso, f as zonedDayStart, h as zonedDayStartIso, p as zonedDayString };
